import * as yup from 'yup'

export const approveRequisitionSchema = yup.object().shape({
  approveMode: yup.string().required('Please select an approval mode'),
  approvalQuantity: yup.number().when('approveMode', {
    is: 'change_quantity',
    otherwise: schema => schema.notRequired(),
    then: schema => schema.required('Quantity is required').min(1, 'Quantity must be greater than 0')
  })
})
